import { Navigate, Outlet } from 'react-router-dom'
import { useAccess } from '../lib/useAccess'
import { RouteLoader } from './RouteLoader'

// Sits between RequireAuth and the onboarding/partner routes. A signed-in user
// whose partner access has not been approved (status !== 'active') is held on
// the /verification screen until an admin verifies them. On failure to resolve
// access, fall through to /verification rather than the app.
export function RequireApproved() {
  const { data, isLoading } = useAccess(true)
  if (isLoading) return <RouteLoader />
  if (!data || data.status !== 'active') return <Navigate to="/verification" replace />
  return <Outlet />
}
